import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import cs from 'classnames';
import { TaskMap, TaskMapKWK } from './ts-config';
import CircleTaskDetailMap from '../CircleTaskDetailMap';
import { useContext, useMemo, useState } from 'react';
import { isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
// import AreaDetailDrawer from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer';
import AreaDetailDrawer from '@/common/components/business/AreaDetailDrawer';
import UserInfoContext from '@/layout/context';
import { globalExpansionTaskAlias, globalOpeningAreaAlias } from '@/common/utils/ways';
import { useSelector } from 'react-redux';
import { isHighlightEmergencyDegree, isHighlightChancePointEmergencyDegree } from '../ts-config';

interface DrawerData{
  open:boolean;
  id:string
}

/**
 * 拓店任务-详情-基本信息-带商圈
 * @description
 * 拓店任务：直营-详情
 */
const CircleBasicInfo = (props: {
  taskDetail:any;
  chancePointList?: any;
  /** 自定义标题 */
  title?: string;
  /** 支持查看详情 */
  hideClusterDetail?: boolean;
  className?: string;
}) => {

  const { taskDetail, chancePointList, title, hideClusterDetail, className } = props;
  const [drawerData, setDrawerData] = useState<DrawerData>({ // 选址地图详情抽屉
    open: false,
    id: ''
  });

  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);
  const openingAreaTaskAlias = useMemo(() => {
    return globalOpeningAreaAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs]);
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);

  // 是否卡旺卡租户,0626改为是否拓店任务模版
  const isKwk = useMemo(() => {
    return (tenantCheckData?.taskTemplateCode) === 'clusterB';
  }, [tenantCheckData]);

  const basicTaskInfo = useMemo(() => {
    if (!isNotEmptyAny(taskDetail)) return {};
    const { modelClusterInfo, manager, emergencyDegreeName, targetProvinceName, targetCityName, targetDistrictName, signShopCount, expectDropInDate } = taskDetail;
    return {
      modelClusterName: modelClusterInfo?.modelClusterName,
      manager,
      emergencyDegreeName,
      targetAdress: `${targetProvinceName && targetProvinceName !== targetCityName ? targetProvinceName + '/' : ''}${targetCityName ? targetCityName + '/' : ''}${targetDistrictName ?? ''}`,
      signShopCount,
      expectDropInDate,
      spotSurveyEmergencyDegreeName: taskDetail?.spotSurveyEmergencyDegreeName,
      chancePointEmergencyDegreeName: taskDetail?.chancePointEmergencyDegreeName,
    };
  }, [taskDetail]);

  const methods = useMethods({

    /**
     * @description 点击商圈名称
     */
    handleClickClusterName: () => {
      const modelClusterId = taskDetail?.modelClusterInfo?.modelClusterId;
      if (!modelClusterId) return;
      setDrawerData({
        open: true,
        id: modelClusterId
      });
    },

    /**
     * @description 是否红色高亮
     * @param key 字段名
     * @return 高紧急度时返回true
     */
    isRedColorValue(key: string) {
      if (isKwk) {
        switch (key) {
          case 'spotSurveyEmergencyDegreeName':
            return isHighlightChancePointEmergencyDegree(taskDetail['spotSurveyEmergencyDegree']);
          case 'chancePointEmergencyDegreeName':
            return isHighlightChancePointEmergencyDegree(taskDetail['chancePointEmergencyDegree']);
          default:
            break;
        }

        return ['spotSurveyEmergencyDegreeName', 'chancePointEmergencyDegreeName'].includes(key) && isHighlightChancePointEmergencyDegree(taskDetail[key]);
      }
      return key === 'emergencyDegreeName' && isHighlightEmergencyDegree(taskDetail.emergencyDegree);
    }
  });

  return <div className={cs(styles.basicWrapper, className || '')}>
    <div className={styles.basicInfo}>
      <V2Title
        type='H2'
        divider
        text={title || `${expansionTaskAlias || '任务'}基本信息`}
      />
      {
        Object.entries(isKwk ? TaskMapKWK : TaskMap).map(([key, label], index) => {
          const _label = key === 'modelClusterName' ? openingAreaTaskAlias : label;
          return <div key={index}>
            <div className={styles.label}>{_label}</div>
            <div className={styles.value}>
              {(key === 'modelClusterName' && !hideClusterDetail)
                ? <a className={'color-primary-dark'} onClick={methods.handleClickClusterName}>{basicTaskInfo[key] || '-'}</a>
                : methods.isRedColorValue(key) ? <span style={{ color: 'red' }}>{(basicTaskInfo[key] || '-')}</span> : (basicTaskInfo[key] || '-')}
            </div>
          </div>;
        })
      }
    </div>
    <div className={cs(styles.basicMap, isKwk && styles.isKwk)}>
      <CircleTaskDetailMap
        businessDetail={taskDetail}
        chancePointList={chancePointList}
      />
    </div>
    <AreaDetailDrawer
      drawerData={drawerData}
      setDrawerData={setDrawerData}
      viewChanceDetail={false}
      showCollect={false}
    />
  </div>;

};

export default CircleBasicInfo;
